import {Artikel} from "./artikel";

export class Nachfolgeartikel extends Artikel {

}
